module.exports = __webpack_public_path__ + "static/media/header-mobile.0f532683.png";